import type {MaterialFunctionList} from "../../../types/materialFunctions.types";

import {deleteMaterialFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialFunctionKeys, materialFunctionMutationKeys} from "../../../materialFunction-keys";

export function deleteMaterialFunctionMutationOptions() {
  const listFilter = {queryKey: materialFunctionKeys.lists()};

  return mutationOptions({
    mutationFn: (materialFunctionId: string) => deleteMaterialFunction(materialFunctionId),
    mutationKey: materialFunctionMutationKeys.deleteMaterialFunction,
    onMutate: async (deletedId, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<MaterialFunctionList>(listFilter);

      for (const [key, list] of previousLists) {
        const params = key[2];

        if (
          !list ||
          typeof params !== "object" ||
          params === null ||
          !("state" in params) ||
          params.state !== "ACTIVE" ||
          !list.items.some((item) => item.materialFunctionId === deletedId)
        ) {
          continue;
        }

        client.setQueryData<MaterialFunctionList>(key, {
          ...list,
          items: list.items.filter((item) => item.materialFunctionId !== deletedId),
          meta: {...list.meta, total: Math.max(0, list.meta.total - 1)},
        });
      }

      return {previousLists};
    },
    onError: (_error, _deletedId, context, {client}) => {
      for (const [key, snapshot] of context?.previousLists ?? []) {
        client.setQueryData(key, snapshot);
      }
    },
    onSuccess: async (_data, deletedId, _context, {client}) => {
      client.removeQueries({queryKey: materialFunctionKeys.detail(deletedId)});
      await client.invalidateQueries(listFilter);
    },
  });
}
